var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.514 3.24729C12.3332 3.0665 12.0388 3.0665 11.858 3.24729C11.6772 3.42808 11.6772 3.72244 11.858 3.90323C13.5408 5.58598 13.5408 8.32334 11.858 10.0038C11.6772 10.1846 11.6772 10.4789 11.858 10.6597C11.9484 10.7501 12.0666 10.7965 12.1848 10.7965C12.303 10.7965 12.4212 10.7501 12.5116 10.6597C14.5583 8.61539 14.5583 5.29162 12.514 3.24729Z",
    fill: "#393939",
    stroke: "#393939",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8954 1.86586C13.7146 1.68507 13.4203 1.68507 13.2395 1.86586C13.0587 2.04665 13.0587 2.34102 13.2395 2.52181C14.4239 3.70622 15.0752 5.28003 15.0752 6.95351C15.0752 8.62698 14.4239 10.2031 13.2395 11.3852C13.0587 11.566 13.0587 11.8604 13.2395 12.0411C13.3299 12.1315 13.4481 12.1779 13.5663 12.1779C13.6845 12.1779 13.8027 12.1315 13.8931 12.0411C15.2514 10.6829 16 8.87499 16 6.95351C16 5.03202 15.2537 3.22411 13.8954 1.86586Z",
    fill: "#393939",
    stroke: "#393939",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15892 4.20853H1.58605V9.69846H1.3907C0.901957 9.69846 0.5 9.2965 0.5 8.80776V4.86744C0.5 4.50386 0.795337 4.20853 1.15892 4.20853Z",
    fill: "white",
    stroke: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73488 1.04389L8.79927 1.00497L8.85527 0.954728C8.96023 0.860563 9.09233 0.80652 9.23142 0.800103C9.49229 0.804974 9.6314 0.981839 9.63257 1.16065V12.6948C9.63257 12.9299 9.44774 13.1013 9.25246 13.1048L9.2495 13.1049C9.02363 13.1097 8.80338 13.0268 8.63772 12.8756L8.58471 12.8273L8.52394 12.7891L3.81318 9.83104V4.01908L8.73488 1.04389Z",
    fill: "white",
    stroke: "#393939",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOn);
export default __webpack_public_path__ + "static/media/voice_on.f2eba98243f8e4ff58237bd7df805fc5.svg";
export { ForwardRef as ReactComponent };